const LOCALE_MAP = { en: 'en-US', ja: 'ja-JP' };

function resolveIntlLocale(locale) {
  return LOCALE_MAP[locale] ?? 'en-US';
}

function toDate(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDate(value, locale = 'en', { emptyValue = '—', dateStyle = 'short' } = {}) {
  const date = toDate(value);
  if (!date) return emptyValue;

  if (locale === 'ja') {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}/${m}/${d}`;
  }

  return date.toLocaleDateString(resolveIntlLocale(locale), { dateStyle });
}

export function formatDateTime(value, locale = 'en', options = {}) {
  const date = toDate(value);
  if (!date) return options.emptyValue ?? '';

  const { emptyValue: _emptyValue, ...formatOptions } = options;
  const resolved = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    ...formatOptions,
  };

  for (const key of Object.keys(resolved)) {
    if (resolved[key] === undefined) {
      delete resolved[key];
    }
  }

  return date.toLocaleString(resolveIntlLocale(locale), resolved);
}
